<template lang="pug">
#layout.mobile(:class='name')
  .wrapper.centered
    .main-panel(:class="{ 'loading' : loading }")
      .navless-layout-wrapper
        .row.navless-main-body-wrapper
          .container-fluid
            .navless-main-body.col-md-12(ref='currentModule')
              slot
      //- md-footer
      ed-tab-nav.tabs(
        v-if='tabs.length'
        bottom-tabs
        wide
        workflow
        ref='steps'
        @tabSelected='enterStep'
      )
        ed-tab(completed v-for='tab in tabs' :key='tab.label' :title='tab.label')
          component(:is='tab.component')
            span(slot='title') {{ tab.title }}
</template>

<script>

import MdFooter from '@/components/Footer'
import Modules from '@/components/_modules'
import SiteMap from '@/core/site-map'
import { EventBus } from '@/event-bus'

const handleUserScalable = () => {
  const meta = document.getElementById('layout-viewport')
  const hasEmbed = document.querySelector('iframe[srcdoc*="embed"]')
  if (hasEmbed) {
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.5, user-scalable=1'
  } else {
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'
  }
}

export default {
  components: {
    MdFooter,
    SiteMap
  },

  mounted() {
    const currentTab = this.$refs.currentModule.children[0].__vue__
    this.tabs = currentTab && currentTab.tabs || []

    handleUserScalable()
  },

  beforeCreate() {
    const meta = document.createElement('meta')
    meta.id = 'layout-viewport'
    meta.name = 'viewport'
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.5, user-scalable=1'
    document.head.appendChild(meta)

    global.config = {
      namespace: 'evedpay',
      layout: 'mobile',
      title: 'EvedPay',
      sitemap: {
        evedpay: {
          Cards: {
            alias: 'cards',
            subtabs: {
              Cards: 'Cards',
              Transactions: 'Transactions'
            }
          }
        }
      },
      enableThemes: true,
      start: '/evedpay'
    }
  },

  data() {
    return {
      name: 'layout-navless',

      source: null,
      description: '',
      tabs: []
    }
  },

  computed: {
    loading() {
      return this.$loading
    },

    pageName() {
      const layout = this
      let page = ''

      if (this.$route.params.section &&
        Modules[this.$route.params.page + '/' + this.$route.params.section]
      ) {
        page = Modules[this.$route.params.page + '/' + this.$route.params.section]
      } else {
        page = Modules[this.$route.params.page]
      }

      if (page) {
        // When module is async, set description after load
        if (page.module &&
            typeof page.module === 'function' &&
            this.$route.params.action &&
            Modules[this.$route.params.section + '/' + this.$route.params.action]
        ) {
          Modules[this.$route.params.section + '/' + this.$route.params.action]().then((v) => {
            if (v) {
              layout.description = v.description
            }
          })
        }

        return (
                (page.module && typeof page.module !== 'function' && ' ') ||
                (page.module && page.module.description) ||
                (page.module && typeof page.module === 'function' ? '' : '')
        )
      } else {
        return ''
      }
    }
  },

  created () {
    if (this.$route.params.page && this.$route.params.section && this.$route.params.action) {
      this.$routerHistory.save([
        '/' + this.$route.params.namespace + '/' + this.$route.params.page + '/' + this.$route.params.section + '/',
        '/' + this.$route.params.namespace + '/' + this.$route.params.page + '/' + this.$route.params.section + '/' + this.$route.params.action
      ])
    }
    this.source = this.$route.query['back-to'] || this.$routerHistory.previous().path

    EventBus.$off('openAttachment')
    EventBus.$on('openAttachment', () => {
      handleUserScalable()
    })

    EventBus.$off('closeAttachment')
    EventBus.$on('closeAttachment', () => {
      handleUserScalable()
    })
  },

  methods: {
    cleanup: function () {
      // this.description = ''
      this.$destroy()
    },
    enterStep: function (tab) {
      //
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

#layout.mobile >>> .loading.main-panel {
  &:before, &:after {
    display: none;
  }
}

#layout.mobile >>> .loading:after {
  background: #fff;
}

#layout.mobile >>> .module {
  padding-bottom: 260px;
}

body {
  @include theme() { background: v(background) }
  height: 100vh;
}

body .navless-layout-wrapper,
body .navless-main-body-wrapper {
  min-height: 100%;
  padding: 0;
}

.main-panel .content.module {
  min-height: calc(100% - 123px);
}

.logo {
  display: inline-block;
  padding-bottom: .75rem;
  min-height: 50px;
  background-position: 10px 100%;
  margin-top: 14px;
}

.container-fluid {
  position: relative;
}

.navless-layout-wrapper {
  @include theme() { background: v(canvas) }
  padding-bottom: 1rem;
  //height: 100vh;

  >>> .dawn-modal-container {
    width: 100%;
    margin-top: 2rem;
  }

  >>> .navless-layout-header {
    margin-left: -16px;
    margin-right: -16px;
    padding: 0.2rem 1rem !important;
    max-height: 2rem;

    a {
      color: #fff !important;
    }
  }
  .navless-layout-header, >>> .navless-layout-header {
    padding: $side-padding;
    position: relative;
    height: 5rem;

    .navless-page-name {
      display: inline-block;
      position: absolute;
      left: 11rem;
      top: 1.2rem;

      h2 {
        margin: 0;
        font-size: $font-size-large;
      }
    }

    @include theme() {
    background: v(primary-04);
    color: v(canvas);
    }

    .navless-page-close {
      text-align: right;
      position: absolute;
      right: $side-padding;
      bottom: 1.7rem;
      text-transform: uppercase;
      font-size: $font-size-xsmall;

      a {
        @include theme() { color: v(canvas) }
        transition: all .2s ease-in-out;
        &:hover {
          opacity: .3;
          text-decoration: none;
        }
        i {
          font-size: $font-size-xlarge;
          margin-left: .1rem;
          vertical-align: middle;
          margin-top: -0.15rem;
        }
      }
    }
  }
}

.navless-main-body-wrapper {
  margin: 0;
}

.navless-main-body {
  @include theme() { background: v(canvas) }
  padding: 0rem 1rem;
}

#layout.mobile {
  .navless-layout-header {
    background: #4e2683;
    > .container-fluid {
      text-align: center;
    }
  }
  .logo {
    background-image: none;
    margin: 0 auto;
    width: auto;
    img {
      display: block;
      height: 70%;
    }
  }
  .navless-layout-wrapper {
    // min-height: calc(100% - 3rem);
    min-height: 0;
  }
  .tabs {
    // height: calc(100% - 8rem);
    height: calc(100% - 5.5rem);
    >>> .dawn-tab-content {
      height: calc(100% - 0rem);
      padding-top: 0.5rem;
      overflow: auto;
    }
    >>> .dawn-tab-nav {
      display: none;
      padding-top: 0.75rem;
      li {
        text-align: center;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Layouts/mobile.vue